import { useTranslation, observer, Link } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import { mobileFooterLinks } from "../content/footer.js";
import * as IconModule from "./Icon.jsx";
import * as React from "react";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import { socialLinks } from "../content/footer.js";
import { BrandedQRCode } from "./BrandedQRCode.jsx";
import * as SiteState from "../state/siteStore.js";
import * as jsxRuntime from "react/jsx-runtime";
import { footerColumns } from "../content/footer.js";
import { CookieSettingsModal } from "./CookieSettingsModal.jsx";
var wechatImage = "/" + "static/gongzhonghao.0b2d09008933f5c7.jpg";
function FooterLogo({ className: className, height: height = 40 }) {
  return (
    <img
      src={"/images/15token-logo-dark.png"}
      alt={"15Token"}
      className={className}
      style={{
        height: `${height}px`,
        width: "auto",
        display: "block",
      }}
    />
  );
}
function FooterCopyright() {
  return null;
}
function FooterSocialLink({ href: href, icon: icon }) {
  return null;
}
let Footer = observer(() => {
  return (
    <footer
      className={
        "bg-black pt-[40px] pb-[24px] px-[16px] md:pt-[80px] md:pb-[32px] md:px-[60px] w-full"
      }
    >
      <div
        className={
          "flex flex-col xl:flex-row xl:justify-between gap-[24px] xl:gap-0"
        }
      >
        <div className={"flex flex-col gap-[24px] shrink-0"}>
          <div className={"flex flex-col gap-[19px]"}>
            <div className={"h-[40px]"}>
              <a
                href={"https://www.15token.win/home"}
                target={"_blank"}
                rel={"noopener noreferrer"}
                aria-label={"15Token"}
                title={"15Token"}
                className={"inline-block h-full hover:opacity-80 transition-opacity"}
              >
                <FooterLogo height={40} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
});
export { wechatImage, FooterLogo, FooterCopyright, FooterSocialLink, Footer };
